import { ValueOf } from '~/types/value-of'

export const contentType = {
  NOTICE: 'NOTICE',
  EVENT: 'EVENT',
  RESEARCH: 'RESEARCH',
  BLOG: 'BLOG',
} as const
export type contentType = ValueOf<typeof contentType>

export const orderByType = {
  LATEST: 'LATEST',
  OLDEST: 'OLDEST',
  VIEWS: 'VIEWS',
} as const
export type orderByType = ValueOf<typeof orderByType>

export const eventType = {
  INTELLIGENCE: 'INTELLIGENCE',
  DISCLOSURE: 'DISCLOSURE',
} as const
export type eventType = ValueOf<typeof eventType>

const combinatedType = {
  ...contentType,
  ...eventType,
} as const
export const { EVENT, ...contentDetailType } = combinatedType
export type contentDetailType = ValueOf<typeof contentDetailType>